import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'

export const useStyles = makeStyles()(() => ({
  card: {
    boxSizing: 'border-box',
    width: '100%',
    maxHeight: 500,
    backgroundColor: C.cardBg,
    border: `1px solid ${C.divider}`,
    borderRadius: 8,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    overflow: 'hidden',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
    flex: '1 1 auto',
    minHeight: 0,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    flexShrink: 0,
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
    flex: '1 1 auto',
  },
  headerAction: {
    flexShrink: 0,
    marginLeft: 'auto',
  },
  headerIcon: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: C.iconBoxBg,
    borderRadius: 4,
    '& svg': { fontSize: 12, color: C.darkText },
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: C.darkText,
    margin: 0,
  },
  scrollWrap: {
    position: 'relative',
    width: '100%',
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex',
  },
  // The shared loader is sized for full-page use with fixed-px internals we
  // can't resize from here, so scale the whole subtree down to fit this short
  // card. `overflow: hidden` keeps it from colliding with the send pill.
  loading: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    '& > *': {
      transform: 'scale(0.6)',
      transformOrigin: 'center',
    },
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    flex: '1 1 auto',
    minHeight: 0,
    maxHeight: 280,
    overflowY: 'auto',
  },
  row: {
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: C.cardBg,
    border: `1px solid ${C.todoRowBorder}`,
    borderRadius: 8,
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
    textAlign: 'left',
    font: 'inherit',
  },
  rowIcon: {
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: 4,
    '& svg': { fontSize: 16, color: C.mutedText },
  },
  rowText: {
    flex: '1 0 0',
    minWidth: 0,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
    margin: 0,
  },
  pill: {
    boxSizing: 'border-box',
    width: '100%',
    backgroundColor: C.cardBg,
    border: `1px solid ${C.todoPillBorder}`,
    borderRadius: 200,
    boxShadow: '0px 0px 10px 0px rgba(191,84,142,0.2)',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    overflow: 'hidden',
    flexShrink: 0,
  },
  pillButton: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: 8,
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    '& svg': { fontSize: 12, color: C.mutedText },
    '&:hover': { backgroundColor: C.todoButtonBg },
  },
  input: {
    flex: '1 0 0',
    minWidth: 0,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: 12,
    lineHeight: '16px',
    color: C.darkText,
    '&::placeholder': {
      color: C.mutedText,
      fontWeight: 400,
    },
  },
}))
